// SignalR Message Logger - Central utility for logging SignalR messages
// This provides a consistent interface for logging message events

// Event bus for custom SignalR message events
class SignalRMessageEventBus {
  private listeners: ((method: string, data: any) => void)[] = [];

  // Register a listener for message events
  public subscribe(callback: (method: string, data: any) => void) {
    this.listeners.push(callback);
    return () => {
      this.listeners = this.listeners.filter(listener => listener !== callback);
    };
  }

  // Publish a message event to all listeners
  public publish(method: string, data: any) {
    this.listeners.forEach(listener => {
      try {
        listener(method, data);
      } catch (e) {
        console.error('[SignalRLogger] Error in message listener:', e);
      }
    });
  }
}

// Singleton instance
export const signalRMessageEvents = new SignalRMessageEventBus();

// Utility function to log SignalR messages
export function logSignalRMessage(method: string, ...args: any[]) {
  console.log(`[SignalR Received] ${method}:`, ...args);
  
  // Clean and prepare data for logging
  const data = args.length === 0 
    ? null 
    : args.length === 1 
      ? args[0] 
      : [...args];
  
  // Publish the message to any listeners
  signalRMessageEvents.publish(method, data);
}

export default logSignalRMessage;
